<template>
    <button v-on:click="toggleFilter" class="product-filter">
        {{name}}
    </button>
</template>
<script>
import {VueState as $store} from "../Store/index"
import {mapActions} from 'vuex'
import {FilterType} from "../@types/Filters"

export default {
    data() {
        return {
            isActive: false
        }
    },
    props: {
        name: String,
        value: Number,
        handle: {
            type: String,
            default: 'parent'
        }
    },
    methods: {
        ...mapActions([
            'addFilter',
            'removeFilter'
        ]),
        toggleFilter() {
            let payload = {
                type: FilterType.Meta,
                handle: this.handle,
                value: this.value,
                name: this.name
            }
            if (this.isActive) {
                this.removeFilter(payload)
            } else {
                this.addFilter(payload)
            }
        }
    }
}
</script>